<template>
<div class="form-row">
  <div class="form-group">
    <input style="display: none" ref="input_file" @change="selected_file" type="file"
      class="form-control" :accept="allow_mimetypes.join(',')"
      :id="dir" :multiple="multi">

    <div class="dropbox rounded" style="border: 1px dashed #dee2e6;min-height: 6rem;"
      @click="onClick"
      @dragstart="onDrag"
      @dragover="onDrag"
      @drop="onDrop">
      <div class="mx-2">{{ __('Choose a file or drag it here.') }}</div>
      <div class="d-inline-flex ml-0 row">
        <div class="border m-2 d-inline-block p-3 bg-white" style="width:15rem;height:4.6rem;" v-for="file in upload_files" :key="file.num">
          <div class="mt-0">
            {{ file.name }}
            <div  @click="e => delete_file(e, file.num)" class="float-right border rounded-circle border-dark d-inline-flex justify-content-center align-items-center" style="width: 1rem;height: 1rem;margin-top: 0.25rem;cursor: pointer;">x</div>
          </div>
          <div class="progress" v-if="!file.complete && file.messages==''">
            <div class="progress-bar progress-bar-striped" :style="{ width: file.percents+'%' }" style="overflow:visible;">
              <div style="width: calc(13rem - 2px);">{{ file.percents+'%' }}</div>
            </div>
          </div>
          <div class="small" v-else>{{ __('Complete.') }} ({{ getFileSizeStr(file.filesize_value) }})</div>
          <div v-if="file.messages!=''">{{ file.messages }}</div>
          <input type="hidden" :name="file.filename_key" :value="file.filename_value" />
          <input type="hidden" :name="file.filesize_key" :value="file.filesize_value" />
          <input type="hidden" :name="file.original_filename_key" :value="file.name" />
        </div>
      </div>
      <div v-if="multi" class="mx-2 text-muted">{{ __('Up to :limit_size MB per file, up to :limit files can be uploaded simultaneously.').replaceAll().replaceAll(":limit", limit) }}</div>
      <div v-else class="mx-2 text-muted">{{ __('Can upload up to :limit_size').replaceAll(":limit_size", (mime == 'thumbnail') ? limit_size + "MB" : limit_size/1024 + "GB") }}</div>
    </div>
  </div>
</div>
</template>

<script>
  import AWS from 'aws-sdk'

  export default {
    name: "UploadForm",
    props: {
      tag: String,
      mime: String,
      dir: String,
      prefix: String,
      bucket: String,
      pool: String,
      region: String,
      limit: Number,
      limit_size: Number, //MB
      uuid: String,
      mcr: Number,
      file_name: String,
      file_size: String,
      original_name: String,
    },
    data() {
      return {
        upload_bucket: this.bucket,
        pool_id: this.pool,
        default_region: this.region,
        upload_files: [],
        multi: this.multi_upload || false,
        allow_mimetypes: [],
        allowedExtensions: [],
        zip_mode:false,
      }
    },
    methods: {
      selected_file (e) {
        e.stopPropagation();
        e.preventDefault();
        let files = e.target.files ? e.target.files : e.dataTransfer.files;

        if(this.multi){
          this.length = (files.length <= this.limit) ? files.length : this.limit;
          for ( var i = 0; i < this.length; i++ ) {
            this.upload(files[i]);
          }
        }else{
          this.upload_files = [];
          this.upload(files[0]);
        }
        this.$refs.input_file.value = '';
        console.log(this.upload_files);
      },
      upload (file) {
        // console.log('upload from ');
        // console.log(file);

        if (this.limit && (this.upload_files.length + 1) > this.limit) {
          console.log('upload limit');
          return;
        }

        let count = (this.multi) ? this.upload_files.length+1 : "";

        // console.log(count);
        let item = {
          num: count,
          name: file.name,
          percents: 0,
          uploading: false,
          complete: false,
          filename_key: this.prefix + count + '_filename',
          filename_value: 0,
          filesize_key: this.prefix + count + '_filesize',
          filesize_value: 0,
          original_filename_key: 'original' + ((this.prefix == "upload") ? "" : "_" + this.prefix) + count + '_filename',
          messages: "",
          upload: null,
        };


        this.upload_files.push(item);
        const s3 = new AWS.S3(),
              sizeLimit = 1024 * 1024 * this.limit_size,
              options = { partSize: 20 * 1024 * 1024, queueSize: 20 },
              upload_file = file;

         if( !file ){
          alert(this.__('The file is not set.'));
          return;
        }
        
        if( upload_file.size > sizeLimit ) {
          item.messages = 'ファイルサイズオーバー '; // + upload_file.size;
          return;
        }

        let ext = upload_file.name.match(/(.*)(?:\.([^.]+$))/);
        ext = ( ext ) ? ext[2] : "";

       /*
        if( !allow_mimetypes.includes(upload_file.type) ){
          alert('ファイル形式が違います ' + upload_file.type);
          return;
        }
        */
        if (!this.allowedExtensions.includes(ext.toLowerCase())) {
          alert('ファイル形式が違います。' + ext);
          return;
        }

        // const contents_uploads = ['document1', 'document2', 'thumbnail', 'image1', 'image2'];
        // const upload_filename = (contents_uploads.includes(this.prefix)) ? 'uploads/' + filename : filename;

        if(this.mime == "image" && count==1){
          if(ext == "zip"){
            this.zip_mode = true;
          }else{
            this.zip_mode = false;
          }
        }
        if((this.zip_mode && ext != "zip") || (!this.zip_mode && ext == "zip")) {
          item.messages = '同時に利用できません';
          return;
        }

        let str_archive = (ext == "zip") ? "_archive" : "";
        let str_count = (this.multi) ? ('00000'+count).slice(-5) : "00001";

        let filename;
        if(this.mime == "video"){
          if(this.mcr == 1){
            // const filename = `${this.dir}${str_archive}/mcr/${this.uuid}/${this.prefix}_${str_count}.${ext}`;
            filename = `${this.dir}${str_archive}/mcr/${this.uuid}/${file.name}`;
          }else{
            // const filename = `${this.dir}${str_archive}/${this.uuid}/${this.prefix}_${str_count}.${ext}`;
            filename = `${this.dir}${str_archive}/${this.uuid}/${file.name}`;
          }
        }else{
          if(this.mcr == 1){
            filename = `${this.dir}${str_archive}/mcr/${this.uuid}/${this.prefix}_${str_count}.${ext}`;
          }else{
            filename = `${this.dir}${str_archive}/${this.uuid}/${this.prefix}_${str_count}.${ext}`;
          }
        }
        // console.log(filename);

        item.filesize_value = upload_file.size;
        item.filename_value = filename;

        // console.log('bucket=' + this.upload_bucket);
        // console.log('filename=' + filename);
        // console.log('region=' + this.default_region);
        // console.log('pool=' + this.pool_id);

        const params = {
          Bucket: this.upload_bucket,
          Key: filename,
          ContentType: upload_file.type,
          Body: upload_file,
          ACL: "private"
        };
        item.complete = false;
        item.uploading = true;
        // console.log('upload_params1', params);

        this.$emit('uploading', true);
        var _this = this;

        let upload = s3.upload(params, options)
          .on('httpUploadProgress', evt => item.percents = parseInt( (evt.loaded * 100) / evt.total ) );

        upload.send(function(err, data) {
          if(err) console.log(err);
            item.uploading = false;
            _this.$emit('uploading', false);
            item.complete =  true;
            _this.$emit('complete', _this.tag);
        });
        item.upload = upload;
      },

      delete_file(e, num) {
        e.stopPropagation();
        e.preventDefault();
        if(this.multi){
          this.upload_files[num-1].upload.abort();
          this.upload_files.splice(num-1,1);
          this.upload_files.forEach(function(item, index){
            item.num = (index+1);
            item.filename_key = this.prefix + (index+1) + '_filename';
            item.filesize_key = this.prefix + (index+1) + '_filesize';
          }, this);
        }else{
          this.upload_files[0].upload.abort();
          this.upload_files = [];
        }
      },
      onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        this.$refs.input_file.click();
      },
      onDrag: function (e) {
        e.stopPropagation();
        e.preventDefault();
      },
      onDrop: function (e) {
        e.stopPropagation();
        e.preventDefault();

        var dt = e.dataTransfer;

        if(this.multi){
          for (var i = 0; i !== dt.files.length; i++) {
            this.upload( dt.files[i]);
          }
        }else{
          this.upload(dt.files[0]);
        }
      },
      getFileSizeStr: function (size) {
        const kb = 1024;
        const mb = Math.pow(kb, 2);
        const gb = Math.pow(kb, 3);

        if (size <= kb) {
          return size + 'byte';
        } else if (size > kb && size <= mb) {
          return (Math.floor((size / kb) * 10) / 10) + 'KB';
        } else if (size > mb && size <= gb) {
          return (Math.floor((size / mb) * 10) / 10) + 'MB';
        } else {
          return (Math.floor((size / gb) * 10) / 10) + 'GB';
        }
      },
    },
    mounted () {
      // console.log('poolid' + this.pool_id);
        AWS.config.region = this.default_region;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({ IdentityPoolId: this.pool_id });
        AWS.config.credentials.get( err => console.log( err || 'Cognito Itentity Id: ' + AWS.config.credentials.identityId ) );

        this.multi = (this.limit > 1);

        switch (this.mime) {
          case 'video': this.allow_mimetypes = ["video/mp4", "video/mpeg", "video/quicktime", ".mxf", "video/x-matroska"]; break;
          case 'image': this.allow_mimetypes = ["image/png","image/jpeg", "image/jpg", "application/zip"]; break;
          case 'thumbnail': this.allow_mimetypes = ["image/png","image/jpeg", "image/jpg"]; break;
          case 'xml': this.allow_mimetypes = ["text/xml"]; break;
          case 'document': this.allow_mimetypes = [
            "application/pdf",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation"
            ]; break;
        };

        switch (this.mime) {
          case 'video': this.allowedExtensions = ["mp4", "mpeg", "wmv", "mov", "mxf"]; break;
          case 'image': this.allowedExtensions = ['jpg', 'png', 'jpeg', 'zip']; break;
          case 'thumbnail': this.allowedExtensions = ['jpg', 'png', 'jpeg']; break;
          case 'xml': this.allowedExtensions = ["xml"]; break;
        };

        let self = this;
        let arrFileName = this.file_name.split(",").filter(Boolean);
        let arrFileSize = this.file_size.split(",").filter(Boolean);
        let arrOriginal = this.original_name.split(",").filter(Boolean);
        arrFileName.forEach(function(value,index) {
          let count = (self.multi) ? index+1 : "";
          let item = {
            num: count,
            name: arrOriginal[index],
            percents: 100,
            uploading: false,
            complete: true,
            filename_key: self.prefix + count + '_filename',
            filename_value: arrFileName[index],
            filesize_key: self.prefix + count + '_filesize',
            filesize_value: (arrFileSize[index]),
            //original_filename_key: 'original' + count + '_filename',
            original_filename_key: 'original' + ((self.prefix == "upload") ? "" : "_" + self.prefix) + count + '_filename',
            messages: "",
          };
          self.upload_files.push(item);
        });
    }
  }
</script>
